import React from "react";

export const Header = () => {
  return <h2 className="h">Expense Tracker</h2>;
};
